<div class="carousel-container">
  <ng-container *ngFor="let slide of slides; let i = index">
    <div class="carousel-card" [ngClass]="{ select: i == 0 }">
      <div class="white-card">
        <div class="card-title" [innerHTML]="slide.title"></div>
        <div class="card-content"><img src="{{ slide.imageUrl }}" width="100%" alt="Slide step" /></div>
      </div>
      <div class="card-description" [innerHTML]="slide.description"></div>
    </div>
  </ng-container>
</div>
